document.addEventListener("DOMContentLoaded", function () {

    $(document).on('click', '.announcement-delete', (e)=>{
        select = e.currentTarget;

        const confirmed = confirm('Czy na pewno chcesz usunąć to ogłoszenie?');
        if (confirmed) {

            const announcementSlug = select.dataset.announcementSlug;
            const ensembleSlug = select.dataset.ensembleslug;
            const DivToRemove = document.querySelector(`.announcement-delete[data-announcement-slug="${announcementSlug}"]`).parentElement.closest('.js-list-item');
            const badge = document.querySelector(`.tickets-tab-switch .nav-link.active .badge`);
            const dataCount = document.querySelector(`.active[data-list-items-count]`)
            let count = dataCount.getAttribute('data-list-items-count');

            const url = `/api/announcement/${ensembleSlug}/${announcementSlug}/delete`;
            const xhr = new XMLHttpRequest();
            var csrftoken = $.cookie('csrftoken'); // Get CSRFToken from cookie

            xhr.open("POST", url, true);
            xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            xhr.setRequestHeader('X-CSRFToken', csrftoken);

            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    DivToRemove.remove();
                    count--;
                    badge.innerText = count;
                    dataCount.setAttribute('data-list-items-count', count);
                    };
                };

            // Sending POST
            xhr.send();
        };
    });
});
